import { combineReducers } from 'redux';
import details from './details/reducer';
import home from './home/reducer';

export default combineReducers({
  details,
  home
});
